import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import { ChevronDown, CheckCircle2, Info, Shield, ClipboardList, GraduationCap, Handshake, Globe, Briefcase, User, Factory, Network, PencilRuler} from 'lucide-react';
import '../styles-v2/ServiciosTarjetas.css';
import About from "./About";

// --- SUB-COMPONENTE ACORDEÓN ---
const DesignAccordion = ({ services, t }) => {
    const [openIndex, setOpenIndex] = useState(null);

    if (!services || services.length === 0) return null;

    const leftColumnServices = services.filter((_, index) => index % 2 === 0);
    const rightColumnServices = services.filter((_, index) => index % 2 !== 0);

    const renderCard = (service, originalIndex) => {
        const isOpen = openIndex === originalIndex;
        return (
            <div key={service.id || originalIndex} className={`st-accordion-item ${isOpen ? 'open' : ''}`}>
                {service.badge && (
                    <div className="st-badge">
                        {service.badge}
                    </div>
                )}
                <button
                    onClick={() => setOpenIndex(isOpen ? null : originalIndex)}
                    className="st-accordion-header"
                >
                    <div className="st-accordion-header-left">
                        <div className="st-accordion-icon">
                            {service.icon}
                        </div>
                        <div>
                            <h3 className="st-accordion-title">{service.title}</h3>
                            <p className="st-accordion-desc">{service.description}</p>
                        </div>
                    </div>
                    <ChevronDown size={24} className="st-accordion-arrow" />
                </button>

                <div className="st-accordion-content-wrapper">
                    <div className="st-accordion-content">
                        <div>
                            <h4 className="st-subtitle">
                                <CheckCircle2 size={18} /> {t('services_section.key_detail')}
                            </h4>
                            <ul className="st-features-list">
                                {service.features && service.features.map((feat, i) => (
                                    <li key={i}>{feat}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="st-why-box">
                            <h4 className="st-subtitle">
                                <Info size={18} /> {t('services_section.btn_why')}
                            </h4>
                            <p>{service.why}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="st-accordion-wrapper">
            <div className="st-accordion-column">
                {leftColumnServices.map((service, idx) => renderCard(service, idx * 2))}
            </div>
            <div className="st-accordion-column">
                {rightColumnServices.map((service, idx) => renderCard(service, idx * 2 + 1))}
            </div>
        </div>
    );
};


const ServiciosTarjetas = () => {
    const { t } = useTranslation();
    const { lang } = useParams(); // 3. Obtenemos el idioma de la URL

    // 4. Sincronización obligatoria con la URL
    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang).catch(err => console.error(err));
        }
    }, [lang]);

    const iconsList = [
        { id: 0, icon: <PencilRuler /> },
        { id: 1, icon: <Shield /> },
        { id: 2, icon: <ClipboardList /> },
        { id: 3, icon: <GraduationCap /> },
        { id: 4, icon: <Handshake /> },
        { id: 5, icon: <Globe /> },
        { id: 6, icon: <Briefcase /> },
        { id: 7, icon: <User /> },
        { id: 8, icon: <Factory /> },
        { id: 9, icon: <Network /> },
    ];

    // Obtenemos el array de servicios desde el JSON de traducción
    const translatedServices = t('services_section.cards', { returnObjects: true });

    const services = Array.isArray(translatedServices)
        ? translatedServices.map((translatedItem, index) => {
            const mappedIcon = iconsList[index] ? iconsList[index].icon : <CheckCircle2 />;
            return {
                id: index,
                icon: mappedIcon,
                ...translatedItem
            };
        })
        : [];

    return (
        <section id="servicios" className="section servicios py-16 px-4">
            <div className="services-inner-container max-w-7xl mx-auto">

                {/* Bloque superior con About integrado */}
                <div className="w-full max-w-7xl mx-auto text-center p-4 border border-dashed border-slate-700 bg-slate-900/50 mb-8 rounded-xl text-slate-400">
                    <About />
                </div>

                {/* Contenedor padre con ancho total y flex para centrar hijos */}
                <div className="w-full flex justify-center mb-12 px-4">
                    {/* Subimos a text-5xl en móvil y text-7xl en escritorio */}
                    <h2 className="text-5xl md:text-7xl font-black text-white text-center mx-auto max-w-5xl block w-full leading-tight tracking-tight">
                        {t('services_section.title_offer')}
                    </h2>
                </div>

                {/* Acordeón de Servicios */}
                <DesignAccordion services={services} t={t} />
            </div>
        </section>
    );
};

export default ServiciosTarjetas;